import React from 'react';
import { t, jsx, tscope } from '@i18n/index';
import {
  Csf,
  Address,
  License,
  Payslip,
  Identity,
  Passport,
  Statement,
  CsfComplete,
  AddressComplete,
  LicenseComplete,
  PayslipComplete,
  IdentityComplete,
  PassportComplete,
} from '@assets/images';
import { PATHS as DOCUMENTS_PATHS } from '@navigators/Root/App/Credit/ProofDocuments/constants';

export const ts = tscope('Requisition.documents');

export const DOCUMENT_STATUS = {
  INITIAL: 'initial',
  PENDING: 'pending',
  REJECTED: 'rejected',
  APPROVED: 'approved',
};

export const DOCUMENT_TYPES = {
  OFFICIAL_ID: 'officialId',
  PASSPORT: 'passport',
  ID_CARD: 'idCard',
  PROOF_OF_ADDRESS: 'proofOfAddress',
  PROOF_OF_INCOME: 'proofOfIncome',
  BANK_STATEMENT: 'bankStatement',
  PAYSLIP: 'payslip',
  PROOF_OF_ACTIVITY: 'proofOfActivity',
  TAX_SITUATION: 'taxSituation',
  OPERATING_LICENSE: 'operatingLicense',
};

export const DOCUMENT_KEYS = {
  OFFICIAL_ID: 'OFFICIAL_ID',
  PASSPORT: 'PASSPORT',
  ID_CARD: 'ID_CARD',
  PROOF_OF_ADDRESS: 'PROOF_OF_ADDRESS',
  PROOF_OF_INCOME: 'PROOF_OF_INCOME',
  BANK_STATEMENT: 'BANK_STATEMENT',
  PAYSLIP: 'PAYSLIP',
  PROOF_OF_ACTIVITY: 'PROOF_OF_ACTIVITY',
  TAX_SITUATION: 'TAX_SITUATION',
  OPERATING_LICENSE: 'OPERATING_LICENSE',
};

export const getDocumentTypesData = (type) => ({
  [DOCUMENT_TYPES.OFFICIAL_ID]: {
    title: ts('officialId.title'),
    description: ts('officialId.description'),
    uploadDocumentText: ts('officialId.uploadDocument'),
    PendingImage: Identity,
    CompleteImage: IdentityComplete,
    continuesPath: DOCUMENTS_PATHS.ID,
  },
  [DOCUMENT_TYPES.PASSPORT]: {
    title: ts('passport.title'),
    description: ts('passport.description'),
    uploadDocumentText: ts('passport.uploadDocument'),
    PendingImage: Passport,
    CompleteImage: PassportComplete,
    continuesPath: DOCUMENTS_PATHS.ID_PASSPORT,
  },
  [DOCUMENT_TYPES.ID_CARD]: {
    title: ts('idCard.title'),
    description: ts('idCard.description'),
    uploadDocumentText: ts('idCard.uploadDocument'),
    PendingImage: Identity,
    CompleteImage: IdentityComplete,
    continuesPath: DOCUMENTS_PATHS.ID_OFICIAL,
  },
  [DOCUMENT_TYPES.PROOF_OF_ADDRESS]: {
    title: ts('proofOfAddress.title'),
    description: ts('proofOfAddress.description'),
    uploadDocumentText: ts('proofOfAddress.uploadDocument'),
    PendingImage: Address,
    CompleteImage: AddressComplete,
    continuesPath: DOCUMENTS_PATHS.PROOF_OF_ADDRESS,
  },
  [DOCUMENT_TYPES.PROOF_OF_INCOME]: {
    title: ts('proofOfIncome.title'),
    description: ts('proofOfIncome.description'),
    uploadDocumentText: ts('proofOfIncome.uploadDocument'),
    PendingImage: Payslip,
    CompleteImage: PayslipComplete,
    continuesPath: DOCUMENTS_PATHS.PROOF_OF_INCOME,
  },
  [DOCUMENT_TYPES.BANK_STATEMENT]: {
    title: ts('bankStatement.title'),
    description: jsx(
      'bankStatement.description',
      { t: ts, months: <b>{t('Common.months', { count: 2 })}</b> },
    ),
    uploadDocumentText: ts('bankStatement.uploadDocument'),
    PendingImage: Statement,
    CompleteImage: AddressComplete,
    preferred: true,
    continuesPath: DOCUMENTS_PATHS.PROOF_OF_INCOME_BANK_STATEMENT,
  },
  [DOCUMENT_TYPES.PAYSLIP]: {
    title: ts('payslip.title'),
    description: jsx(
      'payslip.description',
      { t: ts, months: <b>{t('Common.months', { count: 2 })}</b> },
    ),
    uploadDocumentText: ts('payslip.uploadDocument'),
    PendingImage: Payslip,
    CompleteImage: PayslipComplete,
    continuesPath: DOCUMENTS_PATHS.PROOF_OF_INCOME_PAYSLIP,
  },
  [DOCUMENT_TYPES.PROOF_OF_ACTIVITY]: {
    title: ts('proofOfActivity.title'),
    description: ts('proofOfActivity.description'),
    uploadDocumentText: ts('proofOfActivity.uploadDocument'),
    PendingImage: Csf,
    CompleteImage: CsfComplete,
    continuesPath: DOCUMENTS_PATHS.PROOF_OF_ACTIVITY,
  },
  [DOCUMENT_TYPES.TAX_SITUATION]: {
    title: ts('taxSituation.title'),
    description: jsx(
      'taxSituation.description',
      { t: ts, months: <b>{t('Common.months', { count: 3 })}</b> },
    ),
    uploadDocumentText: ts('taxSituation.uploadDocument'),
    PendingImage: Csf,
    CompleteImage: CsfComplete,
    continuesPath: DOCUMENTS_PATHS.PROOF_OF_ACTIVITY_TAX_SITUATION,
  },
  [DOCUMENT_TYPES.OPERATING_LICENSE]: {
    title: ts('operatingLicense.title'),
    description: ts('operatingLicense.description'),
    uploadDocumentText: ts('operatingLicense.uploadDocument'),
    PendingImage: License,
    CompleteImage: LicenseComplete,
    continuesPath: DOCUMENTS_PATHS.PROOF_OF_ACTIVITY_OPERATING_LICENSE,
  },
}[type]);
